import { useRef } from 'react';
import { SketchField, Tools } from '@/@corefabriccanvas';
import Button from '@/components/Button';

const AddDrawingContent = ({
  saveNote,
}: {
  saveNote: (content: string) => void;
}) => {
  const noteSketchRef = useRef<SketchField | null>(null);

  const saveDrawingNote =() => {
    const json = JSON.stringify(noteSketchRef?.current?.toJSON(''))
    saveNote(json);
  }
  return (
    <>
      <SketchField
        ref={noteSketchRef}
        onChange={() => console.log()}
        tool={Tools.Pencil}
        lineColor="red"
        lineWidth={10}
        onZoomChange={() => console.log()}
        height={500}
        width={500}
      />

      <Button
        className="obro-secondary-btn full-w margin-top-10"
        onClick={() => saveDrawingNote()}
      >
        Kaydet
      </Button>
    </>
  );
};

export default AddDrawingContent;
